import styled from 'styled-components';

import { device, hexToRGB, typography } from '@/styles/helpers';

export const ScReferalProgramPage = styled.div`
  position: relative;

  & .content {
    display: grid;
    gap: 64px;
  }
`;

export const ScContainerMain = styled.div`
  position: relative;
  margin-bottom: 88px;

  @media (${device.mobile}) {
    margin-bottom: 32px;
  }
`;

export const ScReferralHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 16px;
  margin-bottom: 48px;
  position: relative;

  .header-text {
    ${typography['headline1']}
    display: flex;
    justify-content: center;

    @media (${device.mobile}) {
      font-size: 28px;
    }
  }

  .header-intro {
    width: 800px;
    margin-bottom: 8px;
    text-align: center;
    ${typography['body1regular']}

    @media (${device.mobile}) {
      width: 100%;
    }
  }

  @media (${device.mobile}) {
    flex-direction: column;
    margin-bottom: 24px;
  }
`;

export const ScBonusCard = styled.div`
  width: 400px;
  padding: 24px;
  background-color: ${({ theme }) => theme.blackColor};
  justify-content: center;
  text-transform: uppercase;
  border-radius: 16px;

  .card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .card-text {
    ${typography['headline2']}
    text-align: center;
    color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
    @media (${device.mobile}) {
      ${typography['headline2mobile']}
    }
  }

  .bonus {
    font-size: 56px;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: 1.68px;
  }
  .card-friend {
    ${typography['headline2']}
    margin-bottom: 32px;
    @media (${device.mobile}) {
      ${typography['headline2mobile']}
    }
  }

  @media (${device.mobile}) {
    width: 100%;
  }
`;

export const ScReferralContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 16px;
  padding: 64px 123px 48px 123px;
  background-color: ${({ theme }) => theme.blackColor};
  z-index: 1;
  border-radius: 24px 24px 0px 0px;

  .header-text {
    ${typography['headline2']}
    margin-bottom: 24px;
    align-self: center;
  }

  @media (${device.mobile}) {
    padding: 32px 16px 48px 16px;
    align-items: end;
  }
`;
